import { matchPath, useLocation } from "react-router"

import { ModeToggle } from "@/components/mode-toggle" // add this
import PlantStatusBanner from "@/components/PlantStatusBanner"
import { PAGE_PATH_MAP } from "@/config.ts"

import { Separator } from "./ui/separator.tsx"
import { SidebarTrigger } from "./ui/sidebar.tsx"

export default function AppHeader() {
  const location = useLocation()
  const activePath = PAGE_PATH_MAP.find((p) => matchPath(p.path, location.pathname))

  return (
    <header className="flex items-center gap-2 p-4 border-b">
      <SidebarTrigger />
      <Separator orientation="vertical" className="mx-2 data-[orientation=vertical]:h-full" />
      <h1 className="text-base font-medium">{activePath ? activePath.title : ""}</h1>

      <div className="ml-auto flex items-center gap-2">
        <PlantStatusBanner />
        <ModeToggle />
      </div>
    </header>
  )
}
